interface Config {
    path: string,
    frames: number;
    initial: number;
}

export default class Player720 {
    private $wrap: JQuery;
    private $canvas: JQuery;
    private config: Config;

    private ctx: CanvasRenderingContext2D;
    private canvas: HTMLCanvasElement;
    private images: HTMLImageElement[];

    private frame_f: number;
    private toframe_f: number;

    private lastframe_i: number;

    private bypass: number;

    constructor(config: Config) {
        this.config = config;

        this.images = [];

        this.frame_f = this.config.initial;
        this.toframe_f = this.frame_f;
        this.lastframe_i = null;
        this.bypass = 2;
    }

    private drawFrame(frame: number): void {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.drawImage(this.images[frame], 0, 0);
    }

    private onFrame(): void {
        let frame_i = Math.round(this.frame_f);

        if (frame_i < 0) {
            frame_i *= -1;

            frame_i = this.config.frames * 1000 - frame_i;
        }

        frame_i = frame_i % this.config.frames;

        if (frame_i != this.lastframe_i) {
            this.drawFrame(frame_i);

            this.lastframe_i = frame_i;
        }

        window.requestAnimationFrame(() => {
            this.onFrame();
        });
    }

    public initHtml($wrap: JQuery): void {
        this.$wrap = $wrap;

        const tf = 1000 / 30;

        this.loadImages(() => {
            this.initCanvas();

            setInterval(() => {
                let d = (this.toframe_f - this.frame_f) * 0.2;

                if (Math.abs(d) < 0.1) {
                    d = 0;
                }

                if (d != 0) {
                    this.frame_f += d;
                }

                if (this.bypass > 0) {
                    this.bypass -= 1 / tf;
                } else {
                    this.bypass = 0;
                }

                if (this.bypass == 0) {
                    this.toframe_f -= 0.5;
                }
            }, tf);
        });
    }

    private initCanvas(): void {
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.images[0].width;
        this.canvas.height = this.images[0].height;
        this.ctx = this.canvas.getContext('2d');

        this.$canvas = $(this.canvas);
        this.$wrap.append(this.$canvas);

        window.requestAnimationFrame(() => {
            this.onFrame();
        });

        let startx = null;
        let startframe = null;

        this.$wrap.on('mousedown touchstart', (e) => {
            if ((<any> e.originalEvent).touches) {
                startx = (<any> e.originalEvent).touches[0].pageX;
            } else {
                startx = e.pageX;
            }

            startframe = this.frame_f;

            this.bypass = 1000;
        });


        $(window).on('mousemove touchmove', (e) => {
            if (startx != null) {
                let xx;
                let ff = 30;

                if ((<any> e.originalEvent).touches) {
                    xx = (<any> e.originalEvent).touches[0].pageX;
                    ff = 10;
                } else {
                    xx = e.pageX;
                }

                const dx = (xx - startx) / ff;

                this.toframe_f = startframe - dx;
            }
        });

        $(window).on('mouseup touchend', (e) => {
            startx = null;
            startframe = null;

            this.bypass = 5;
        });
    }

    private loadImages(onload: () => void): void {
        let loaded = 0;

        for (let i = 0; i < this.config.frames; i++) {
            const image = new Image();

            image.addEventListener('load', (e) => {
                loaded ++;

                if (loaded == this.config.frames) {
                    onload();
                }
            });

            image.src = this.config.path + '/' + i + '.jpg';

            this.images.push(image);
        }
    }
}
